import * as React from 'react';
import { ClassesProps } from 'react-jss';

import { getVerbalHours } from '../../../../utils/format';
import { getHowLongMinutesToAirport } from '../../../../utils/initial-state';


export interface MapLegendProps {
    beachType: string | null;
    beachSandType: string | null;
    distanceToAirport: number | null;
    distanceToBeach: number | null;
    howLongMinutesToCenterCity: number | null;
    isCenterCity: boolean;
}

interface StyledMapLegendProps extends ClassesProps, MapLegendProps {}


export class MapLegend extends React.Component<StyledMapLegendProps, {}> {

    render() {
        const { classes } = this.props;

        if (!this.hasData) {
            return null;
        }

        return (
            <ul className={classes.container}>
                {this.props.beachSandType &&
                    <li className={classes.item}>
                        <b>{this.props.beachSandType}</b>
                    </li>
                }
                {this.props.beachType &&
                    <li className={classes.item}>
                        {this.props.beachType}
                    </li>
                }
                {this.distanceToAirport !== null &&
                    <li className={classes.item}>
                        {this.distanceToAirport}
                    </li>
                }
                {this.distanceToCenterCity !== null &&
                    <li className={classes.item}>
                        {this.distanceToCenterCity}
                    </li>
                }
                {this.props.distanceToBeach &&
                    <li className={classes.item}>
                        {this.textToDistanceBeach}
                    </li>
                }
            </ul>
        );
    }

    private get hasData(): boolean {
        return !!this.props.isCenterCity ||
            !!this.props.beachSandType ||
            !!this.props.beachType ||
            !!this.props.distanceToAirport ||
            !!this.props.distanceToBeach ||
            !!this.props.howLongMinutesToCenterCity;
    }

    private get distanceToAirport(): string | null {
        if (!this.props.distanceToAirport) {
            return null;
        }

        const hoursToAirport = getHowLongMinutesToAirport(this.props.distanceToAirport);

        if (!hoursToAirport) {
            return null;
        }

        if (hoursToAirport < 1) {
            return 'Меньше часа до аэропорта';
        }

        return `${hoursToAirport} ${getVerbalHours(hoursToAirport)} до аэропорта`;
    }

    private get distanceToCenterCity(): string | null {
        if (this.props.isCenterCity) {
            return 'В центре';
        }

        if (!this.props.howLongMinutesToCenterCity) {
            return null;
        }

        if (this.props.howLongMinutesToCenterCity < 60) {
            return 'Меньше часа до центра';
        }

        const hours = Math.floor(this.props.howLongMinutesToCenterCity / 60);

        return `${hours} ${getVerbalHours(hours)} до центра`;
    }

    private get textToDistanceBeach(): string {
        if (!this.props.distanceToBeach)
            return '';

        if (this.props.distanceToBeach <= 0.2)
            return '1-я линия — до пляжа не более 200 м';

        if (this.props.distanceToBeach <= 1)
            return '2-я линия — до пляжа не более 1000 м';

        return '3-я линия — до пляжа не более 2000 м';
    }
}
